import Swiper from "swiper/bundle"

var swiper = new Swiper(".mySwiper", {
    autoplay: {
        delay: 5000,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    speed: 2000,
    loop: true,
});